import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-yellow-200 m-8 rounded-xl shadow-lg p-6 flex flex-col relative" }
const _hoisted_2 = { class: "w-full h-full flex flex-col justify-between p-4" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  ref: "profileContainer",
  class: ""
}
const _hoisted_6 = { class: "w-48 h-48 rounded-full overflow-hidden shadow-lg flex justify-center items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "mt-4 text-2xl font-bold" }
const _hoisted_9 = { class: "mt-2 w-96 text-center" }
const _hoisted_10 = { class: "flex justify-center text-xl py-4" }
const _hoisted_11 = { class: "flex flex-col items-center mr-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-50" }, "Answers", -1)
const _hoisted_13 = { class: "flex flex-col items-center mx-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-50" }, "Points", -1)
const _hoisted_15 = { class: "flex flex-col items-center ml-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "opacity-50" }, "Rank", -1)
const _hoisted_17 = {
  key: 1,
  class: "ml-4"
}
const _hoisted_18 = { class: "flex flex-col mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_popup = _resolveComponent("the-popup")!
  const _component_question_card = _resolveComponent("question-card")!
  const _component_pagination_buttons = _resolveComponent("pagination-buttons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.showPopup)
      ? (_openBlock(), _createBlock(_component_the_popup, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($data.bioText = $event)),
                  placeholder: "Enter a cool bio!",
                  type: "text",
                  class: "rounded-lg h-14 w-full p-2 px-4 outline-none border border-black focus:border-2 focus:border-blue-700 shadow-sm"
                }, null, 512), [
                  [_vModelText, $data.bioText]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_the_button, {
                  content: "Save",
                  type: "ternary",
                  size: "small",
                  onClick: $options.saveChanges
                }, null, 8, ["onClick"]),
                _createElementVNode("div", {
                  class: "ml-4 text-black cursor-pointer text-lg",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.discardChanges && $options.discardChanges(...args)))
                }, " Cancel ")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$store.state.mobileResponsive ? 'flex-col' : '', "flex items-center"])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$store.state.mobileResponsive ? 'order-3' : 'w-1/4 ml-20', "items-center"])
        }, [
          (String(this.$route.params.user_id) === String($data.currentUserId.currentUserId))
            ? (_openBlock(), _createBlock(_component_the_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($data.toggleSavedAnswers = !$data.toggleSavedAnswers)),
                content: "Saved Questions",
                type: "primary",
                size: "large",
                disabled: $data.disableBtn,
                key: $data.disableBtn
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$store.state.mobileResponsive ? 'w-full' : 'w-2/4', "flex flex-col items-center py-8"])
        }, [
          _createElementVNode("div", _hoisted_6, [
            (String(this.$route.params.user_id) === String($data.currentUserId.currentUserId))
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "file",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.onFileChanged && $options.onFileChanged(...args))),
                  class: "z-50 bg-gray-200 w-48 absolute h-32 rounded-full opacity-0 cursor-pointer"
                }, null, 32))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              class: "w-48 h-48 relative",
              src: $data.userImg || _ctx.$store.state?.alternativeImg,
              alt: "profile pic"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString($data.username), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString($data.bioText), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$store.state.mobileResponsive ? 'order-2 mb-2': 'mr-20 w-1/4', "flex justify-center items-center"]),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($options.editBio && $options.editBio(...args)))
        }, [
          (String(this.$route.params.user_id) === String($data.currentUserId.currentUserId))
            ? (_openBlock(), _createBlock(_component_the_button, {
                content: "Edit Bio",
                type: "primary",
                size: "large",
                disabled: $data.disableBtn,
                key: $data.disableBtn
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", null, _toDisplayString($data.answersCount), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", null, _toDisplayString($data.pointsCount), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, _toDisplayString($data.rank), 1)
        ])
      ])
    ], 512),
    ($data.toggleSavedAnswers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.renderedQuestions, (question) => {
              return (_openBlock(), _createBlock(_component_question_card, {
                key: question,
                question: question
              }, null, 8, ["question"]))
            }), 128))
          ]),
          _createVNode(_component_pagination_buttons, {
            class: "mb-10",
            list: $data.questions,
            onPaginatedList: $options.syncCurrentList
          }, null, 8, ["list", "onPaginatedList"])
        ]))
      : _createCommentVNode("", true)
  ]))
}